// @flow
import type { PlanActionType } from './actions';
import type { ChangePlanAction } from '../Subscription';

export type PlansStateType = {|
  changePlanDate: string,
  data: Object[],
|};

const initialState: PlansStateType = {
  changePlanDate: 'now',
  data: [],
};

export const plansReducer = (state: PlansStateType = initialState, action: PlanActionType | ChangePlanAction) => {
  switch (action.type) {
    case 'SET_PLANS':
      return {
        data: action.payload.plans,
      };
    case 'UPDATE_CHANGE_PLAN_DATE':
      return {
        ...state,
        changePlanDate: action.date,
      };
    default:
      return state;
  }
};
